function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home---Sticky-Table",
  transform: "translate(-205.000000, -418.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(151.000000, 112.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-30",
  transform: "translate(30.000000, 70.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-29",
  transform: "translate(0.000000, 216.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-26",
  transform: "translate(24.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#009FDF",
  cx: 24,
  cy: 24,
  r: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(13.000000, 16.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.5507993,0.285163935 C18.3805108,0.104632988 18.1472764,0.00218636095 17.9024868,2.01320442e-14 C17.9000541,2.01320442e-14 17.8979255,2.01320442e-14 17.8957969,2.01320442e-14 C17.653744,2.01320442e-14 17.4214219,0.0986985799 17.2502212,0.274856805 L17.158387,0.369182663 C16.806863,0.730869231 16.8023017,1.31525228 17.1483522,1.68287325 C18.7521046,3.38542376 19.63578,5.62769308 19.63578,7.99645899 C19.63578,10.3655372 18.7524087,12.6078066 17.1483522,14.3100447 C16.8013894,14.677978 16.8065589,15.2639228 17.1596034,15.625297 L17.2517416,15.7196229 C17.4226382,15.8948441 17.6543522,15.992918 17.8957969,15.992918 C17.8985337,15.992918 17.9012704,15.992918 17.9037031,15.992918 C18.1478846,15.9907316 18.3808149,15.8879727 18.5507993,15.7080664 C20.510637,13.6300865 21.5901442,10.8915132 21.5901442,7.99645899 C21.5901442,5.1017171 20.510637,2.36314385 18.5507993,0.285163935 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.95466827,7.99645899 C1.95466827,5.62800541 2.83803966,3.38573609 4.44209615,1.68287325 C4.78875481,1.31525228 4.78388942,0.729932219 4.43114904,0.368245651 L4.33901082,0.273919793 C4.1678101,0.0983862426 3.93609615,2.6423308e-14 3.69434736,2.6423308e-14 C3.69191466,2.6423308e-14 3.68917788,2.6423308e-14 3.68674519,2.6423308e-14 C3.44225962,0.00218636095 3.20902524,0.104632988 3.03904087,0.285163935 C1.07920312,2.36314385 -2.52492471e-13,5.1017171 -2.52492471e-13,7.99645899 C-2.52492471e-13,10.8915132 1.07920312,13.6300865 3.03934495,15.7077541 C3.20963341,15.888285 3.44286779,15.9907316 3.68735337,15.992918 C3.68978606,15.992918 3.69221875,15.992918 3.69465144,15.992918 C3.93640024,15.992918 4.16872236,15.8945317 4.33961899,15.7183735 L4.43175721,15.6237353 C4.78388942,15.2620488 4.78875481,14.6773534 4.44240024,14.3097324 C2.83803966,12.6074942 1.95466827,10.3652249 1.95466827,7.99645899 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5421671,3.88110302 C15.3715745,3.70025973 15.137732,3.59781311 14.8926382,3.59593908 C14.6438954,3.59593908 14.4109651,3.69557467 14.2397644,3.87266991 L14.1950637,3.91889583 C13.8450601,4.28089473 13.841107,4.86402843 14.1865493,5.23102473 C14.8892933,5.97657382 15.2760913,6.95887456 15.2760913,7.99645899 C15.2760913,9.03435577 14.8892933,10.0166565 14.1868534,10.7618933 C13.841107,11.1288896 13.844756,11.7120233 14.1950637,12.0740222 L14.2397644,12.1202481 C14.4106611,12.2973433 14.6438954,12.3969789 14.8868606,12.3969789 C15.137732,12.3954172 15.3715745,12.2926583 15.5421671,12.1121273 C16.5882248,11.0030176 17.1644687,9.54159151 17.1644687,7.99645899 C17.1644687,6.45163882 16.5885288,4.99021269 15.5421671,3.88110302 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.39295192,3.9170218 L7.34794712,3.87079589 C7.17705048,3.69495 6.94472837,3.59625142 6.70297957,3.59625142 C6.70054688,3.59625142 6.69811418,3.59625142 6.69568149,3.59625142 C6.45119591,3.59812544 6.21796154,3.70088441 6.04767308,3.88141536 C5.00191947,4.99021269 4.42597957,6.45163882 4.42597957,7.99677133 C4.42597957,9.54190385 5.00191947,11.0036423 6.04797716,12.1124396 C6.21796154,12.2926583 6.4515,12.3951049 6.69598558,12.3972912 C6.69841827,12.3972912 6.70085096,12.3972912 6.70297957,12.3972912 C6.94472837,12.3972912 7.17705048,12.298905 7.34794712,12.1227468 L7.39295192,12.0765209 C7.74508413,11.7148343 7.74964543,11.1301389 7.40359495,10.7622056 C6.70115505,10.0166565 6.31405288,9.03498044 6.31405288,7.99677133 C6.31405288,6.95918689 6.70085096,5.97688615 7.40359495,5.23133707 C7.74994952,4.86340376 7.74538822,4.27839604 7.39295192,3.9170218 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  cx: 10.7950721,
  cy: 7.96147722,
  rx: 1.9765625,
  ry: 2.03019231
}))))))));
function SvgStreamingAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamingAudio);
export default __webpack_public_path__ + "static/media/streamingAudio.8cb9730771add3b6884e90af31d2b249.svg";
export { ForwardRef as ReactComponent };